module.exports = __webpack_public_path__ + "img/two.4236cc2c.png";